import { ApiError } from "@/api/client/ApiError";

export class UnauthenticatedError extends ApiError {
  public constructor(response: Response) {
    super(response, "Unauthenticated.");

    super.name = "UnauthenticatedError";
  }
}
